import { render, staticRenderFns } from "./input-file.vue?vue&type=template&id=3df2a88f&scoped=true"
import script from "./input-file.vue?vue&type=script&lang=js"
export * from "./input-file.vue?vue&type=script&lang=js"
import style0 from "./input-file.vue?vue&type=style&index=0&id=3df2a88f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df2a88f",
  null
  
)

export default component.exports